module.exports = __webpack_public_path__ + "img/bg.4c19f96c.png";